import { render } from "./EventDetails.vue?vue&type=template&id=3d3cabab&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3d3cabab"

export default script